import { messages } from './messages';

export const Store = {
  messageDescriptor: messages.store,
  id: 'store',
};
